
export const Dates = ["MAY 2021", "MAY 2024", "DECEMBER 2023", "APRIL 2024", "MAY 2023", "APRIL 2021", "AUGUST 2021", "DECEMBER 2022", "NOVEMBER 2022"]
export const Titles = ["DASH: A Web-based IDE", "DriveAlive: Drowsiness Detector", "Cat Finder: Adventure Game", "GoFigure: A Coaching App", "Soma: Pain Manager App", "Pet Garden: Productivity Game", "Boston AI Labs Website", "Frontend Dev Projects", "Ray Tracer"]
export const ClassInfo = [
    "Independent project for Andy Van Dam",
    "Computer Vision with Srinath Sridhar",
    "Augmented Design and Virtual Reality with Mattia Casalegno",
    "Senior Portfolio with Kim Demarco",
    "Internship with Brown Center for Computation and Visualization",
    "Object Oriented Programming with Andy Van Dam",
    "Independent commission for Boston AI Labs",
    "UI/UX with Jeff Huang",
    "Computer Graphics with Daniel Richie"
]
export const Skills = [
    "Hypertext Systems, User Experience Design, Frontend Dev",
    "0-1 Product Design, Frontend Dev, Convolutional Neural Networks",
    "3D Modeling, World Building, Game Design",
    "0-1 Product Design, User Experience Design, Hi-fi Prototyping",
    "Mobile (iOS) Dev, Frontend Dev, User Experience Design",
    "Object Oriented Programming, User Experience Design",
    "User Research, Hi-fi Prototyping",
    "User Experience Design, Adaptive Redesign, User Research",
    "Lighting Models, Intersection Algos, Multithreading"
]
export const Tools = [
    "React, TypeScript, SCSS, MongoDB",
    "Figma, Flask, Python, Tensorflow, HTML/CSS/JS",
    "Blender, Unity, VRChat",
    "Figma, Adobe Illustrator",
    "React Native, JavaScript, Docker",
    "Java, JavaFX",
    "Figma",
    "Figma, React, JavaScript",
    "C++, OpenGL"
]
export const Info = [
    "A responsive redesign and code implementation of my professor's web app.",
    "Given a recorded video, DriveAlive (currently operating on a web browser) will assess the subject's drowsiness level using computer vision.",
    "Cat Finder is an adventure game with the objective of offering users a refuge from the stress of everyday life. ",
    "An app that provides personalized instruction for figure skaters.",
    "Soma is an app which allows users to track and monitor chronic pain. ",
    "A game where players track their productivity and earn pets in exchange. ",
    "A design for the pilot website of Boston AI Labs: a startup company that designs AI technology to detect and combat Retinopathy of Prematurity in newborn infants.",
    "I architected and executed responsive web solutions, and also redesigned existing web pages with mindfulness of UX principles. I also conducted user testing.",
    "I created a ray tracer which parses tree-based scene representations, projects a ray to calculate intersection points, and uses a Phong lighting model to color each pixel of an image."
]

export const Format = [1, 1, 1, 2, 2, 1, 2, 1, 2]